import React from 'react'
import { useEffect } from 'react'
import pic1 from '../components/images/food/pic1.jpg'
import pic2 from '../components/images/food/pic2.jpeg'
import pic3 from '../components/images/food/pic3.jpeg'
import pic4 from '../components/images/food/pic4.jpeg'
import pic5 from '../components/images/food/pic5.jpeg'
import pic6 from '../components/images/food/pic6.jpeg'
import pic7 from '../components/images/food/pic7.jpeg'
import pic8 from '../components/images/food/pic8.jpeg'
// import pic9 from '../components/images/food/pic9.jpeg'
export default function Menu() {
    useEffect(() => {
        document.title = "Mamma's Menu"
    })
    return (
        <>
            <section className='section-intro intro'>
                <h1 className='pic-text'>
                    Mamma's Menu
                </h1>
                <div className="booking intro">
                    <button className='book_btn'>Book Now</button>
                </div>
            </section>
            <div className="mealtype">
                <h1 id='menu-head'>Our Menu</h1>
                <ul className='menu-list'>
                    <li className='meals'>All</li>
                    <li className='meals'>Breakfast</li>
                    <li className='meals'>Lunch</li>
                    <li className='meals'>Dinner</li>
                </ul>
                <div className="menu">
                    <div className="lines">
                        <div className="foodlist">
                            <div className="item">
                                <img src={pic1} alt="food1 pic here" />
                                <div className="meal-des">
                                    <h4>Buttermilk Pancakes</h4><p>$1</p>
                                    <hr />
                                    <span className="spantext">A pancake is a flat cake, often thin and round, prepared from a starch-based batter that may contain eggs, milk and butter and cooked on a frying pan</span>
                                </div>
                            </div>
                            <div className="item">
                                <img src={pic2} alt="food2 pic here" />
                                <div className="meal-des">
                                    <h4>Traditional English Breakfast</h4><p>$1</p>
                                    <hr />
                                    <span className="spantext">The full English breakfast consists of fried eggs, sausages, back bacon, tomatoes, mushrooms, fried bread and often a slice of white or black pudding</span>
                                </div>

                            </div>
                        </div>

                    </div>
                    <div className="lines">
                        <div className="foodlist">
                            <div className="item">
                                <img src={pic3} alt="food1 pic here" />
                                <div className="meal-des">
                                    <h4>Peach Crisp Yogurt Bowls</h4><p>$1</p>
                                    <hr />
                                    <span className="spantext">Bowls of creamy vanilla yogurt, topped with fresh, juicy roasted peaches</span>
                                </div>
                            </div>
                            <div className="item">
                                <img src={pic4} alt="food2 pic here" />
                                <div className="meal-des">
                                    <h4>Pasta Carbonara</h4><p>$1</p>
                                    <hr />
                                    <span className="spantext">Carbonara is an Italian pasta dish from Rome made with eggs, hard cheese, cured pork, and black pepper</span>
                                </div>

                            </div>
                        </div>

                    </div>
                    <div className="lines">
                        <div className="foodlist">
                            <div className="item">
                                <img src={pic5} alt="food1 pic here" />
                                <div className="meal-des">
                                    <h4>Pizza Margherita</h4><p>$1</p>
                                    <hr />
                                    <span className="spantext">Pizza Margherita is a typical Neapolitan pizza, made with San Marzano tomatoes, mozzarella cheese, fresh basil, salt, and extra-virgin olive oil</span>
                                </div>
                            </div>
                            <div className="item">
                                <img src={pic6} alt="food2 pic here" />
                                <div className="meal-des">
                                    <h4>Avocado Bowl</h4><p>$1</p>
                                    <hr />
                                    <span className="spantext">Healthy bowl with avocado, eggs, vegetables. Add your favourite whole grains</span>
                                </div>

                            </div>
                        </div>

                    </div>
                    <div className="lines">
                        <div className="foodlist">
                            <div className="item">
                                <img src={pic7} alt="food1 pic here" />
                                <div className="meal-des">
                                    <h4>Crepes With Berries</h4><p>$1</p>
                                    <hr />
                                    <span className="spantext">Crepes is a type of very thin pancake. Served with cream and berries</span>
                                </div>
                            </div>
                            <div className="item">
                                <img src={pic8} alt="food2 pic here" />
                                <div className="meal-des">
                                    <h4>Chocolate Cake</h4><p>$1</p>
                                    <hr />
                                    <span className="spantext">Chocolate cake is a cake flavored with melted chocolate, cocoa powder</span>
                                </div>

                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </>
    )
}
